import { render, staticRenderFns } from "./PromoMarquee.vue?vue&type=template&id=7778d575&"
import script from "./PromoMarquee.vue?vue&type=script&lang=js&"
export * from "./PromoMarquee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports